import { useState, useEffect, useContext } from "react";
import Request from "../../core/httpClient";
import cogoToast from "cogo-toast";
import { Helmet } from "react-helmet";
import Header from "../header/header";
import { Context } from "../../context";
import SidebarOperacion from "../header/sidebarOperacion";
import Modal from "../UI/ModalTailwind";

const request = new Request();

const BloqcatModal = ({
    isOpen,
    onClose,
    onUpdateCategorySuccess
}) => {
  const { fracActual } = useContext(Context);

  const [bloqcats, setBloqcats] = useState([]);
  const [categories, setCategories] = useState([]);
  const [idCategoria, setIdCategoria] = useState("");
  const [maximoPermitidos, setMaximoPermitidos] = useState("");
  const [editId, setEditId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [restringirReservas, setRestringirReservas] = useState(false);

  // Leer configuraciones
  const getBloqcats = async () => {
    const data = { id: fracActual };
    const response = await request.post("/commonArea/bloqcat/get", data);
    if (!response.error && response.bloqcats) {
      setBloqcats(response.bloqcats);
    }
  };

  // Leer categorías disponibles
  const getCategories = async () => {
    const data = { id: fracActual };
    const response = await request.post("/commonArea/get/categories", data);
    if (!response.error && response.categories) {
      setCategories(response.categories);
    }
  };

  useEffect(() => {
    getBloqcats();
    getCategories();
  }, []);

  useEffect(() => {
    if (fracActual) {
      getBloqcats();
      getCategories();
    }
  }, [fracActual]);

  // Crear nuevo registro
  const handleCreate = async (e) => {
    e.preventDefault();
    const data = {
      id_categoria: parseInt(idCategoria, 10),
      id_fraccionamiento: fracActual,
      maximo_permitidos: parseInt(maximoPermitidos, 10),
      restringir_reservas_dia: restringirReservas ? 1 : 0,
    };
    const response = await request.post("/commonArea/create/bloqcat", data);
    if (!response.error) {
      cogoToast.success("Categoría añadida al subfraccionamiento");
      setIdCategoria("");
      setMaximoPermitidos("");
      setRestringirReservas(false);
      setShowCreateForm(false);
      getBloqcats();
      onUpdateCategorySuccess();
    }
  };

  // Actualizar existente
  const handleUpdate = async (e) => {
    e.preventDefault();
    const data = {
      IdFraccionamiento: fracActual,
      maximo_permitidos: parseInt(maximoPermitidos, 10),
      restringir_reservas_dia: restringirReservas ? 1 : 0,
    };
    const response = await request.put(`/commonArea/bloqcat/update/${editId}`, data);
    if (response.updated) {
      cogoToast.success("Configuración actualizada");
    }
    setMaximoPermitidos("");
    setRestringirReservas(false);
    setEditId(null);
    getBloqcats();
  };

  const handleEdit = (bloq) => {
    setMaximoPermitidos(bloq.maximo_permitidos);
    setRestringirReservas(bloq.restringir_reservas_dia === 1);
    setEditId(bloq.id_bloqueo);
    setShowCreateForm(false);
  };

  const handleDelete = async (id) => {
    const response = await request.delete(`/commonArea/bloqcat/delete/${id}`);
    if (response.deleted) {
      cogoToast.success("Configuración eliminada");
      getBloqcats();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Limitar categorías"
      size="xl"
      showSubmit={false}
      cancelLabel="CERRAR"
    >
        <main className="tw-flex-1 tw-min-h-[65dvh]">
          <div className="tw-max-w-4xl tw-mx-auto">
            <div className="tw-border tw-border-zinc-200 tw-rounded-lg tw-p-4">
              <div className="tw-mb-5">
                <h3 className="tw-font-extrabold tw-text-lg tw-underline tw-text-purple-700">Configuración de Categorías</h3>
                <p className="tw-text-md tw-text-zinc-500">Administra los límites de reservas abiertas por categoría. Usa + para crear una configuración o el ícono de edición para actualizar una existente.</p>
              </div>

              {/* Tabla */}
              <table className="tw-min-w-full tw-border tw-border-gray-200 tw-rounded-md tw-shadow-sm tw-text-sm">
                <thead className="tw-bg-gray-100 tw-sticky tw-top-0">
                  <tr className="tw-text-left tw-text-gray-700">
                    <th className="tw-px-4 tw-py-2">Categoría</th>
                    <th className="tw-px-4 tw-py-2">Máximo de reservas abiertas</th>
                    <th className="tw-px-4 tw-py-2">Restringir máximo de reservas abiertas por día</th>
                    <th className="tw-px-4 tw-py-2 tw-text-center">Editar</th>
                    <th className="tw-px-4 tw-py-2 tw-text-center">Eliminar</th>
                  </tr>
                </thead>
                <tbody className="tw-divide-y tw-divide-gray-200">
                  {categories.map((cat) => {
                    const bloq = bloqcats.find((b) => b.id_categoria === cat.id_categoria);
                    
                    return (
                      <tr key={cat.id_categoria} className="hover:tw-bg-gray-50">
                        <td className="tw-px-4 tw-py-2">
                          {cat.nombre}
                        </td>

                        <td className="tw-px-4 tw-py-2">
                          {bloq && bloq.maximo_permitidos}
                        </td>

                        <td className="tw-flex tw-px-4 tw-py-2 tw-justify-center">
                          {bloq && (
                            <input
                              type="checkbox"
                              checked={Number(bloq.restringir_reservas_dia) === 1}
                              disabled
                            />
                          )}
                        </td>

                       <td className="tw-px-4 tw-py-2 tw-text-center">
                          {bloq ? (
                            <button
                              type="button"
                              onClick={() => handleEdit(bloq)}
                              className="tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-purple-400 tw-text-white tw-px-2 tw-py-1 hover:tw-bg-purple-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-purple-500"
                            >
                              <i className="fas fa-pen tw-text-xs"></i>
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowCreateForm(!showCreateForm)
                                setEditId(null)
                                setMaximoPermitidos("")
                                setIdCategoria(cat.id_categoria)
                              }}
                              className="tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-purple-400 tw-text-white tw-px-2 tw-py-1 hover:tw-bg-purple-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-purple-500"
                            >
                              <i className="fas fa-plus tw-text-xs"></i>
                            </button>
                          )}
                        </td>

                        <td className="tw-px-4 tw-py-2 tw-text-center">
                          {bloq && (
                            <button
                              type="button"
                              onClick={() => handleDelete(bloq.id_bloqueo)}
                              className="btn-red tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-red-400 tw-text-white tw-px-2 tw-py-1 hover:tw-bg-red-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500"
                            >
                              <i className="fas fa-trash tw-text-xs"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Formulario de creación */}
            {showCreateForm && !editId && (
              <div className="tw-border tw-border-zinc-200 tw-rounded-lg tw-p-4 tw-my-5">
                <h3 className="tw-font-extrabold tw-text-lg tw-underline tw-text-purple-700">Configurar categoría</h3>
                <form onSubmit={handleCreate} className="tw-grid tw-grid-cols-[2fr_1fr] tw-gap-4">
                  <input type="hidden" value={idCategoria} />

                  <div className="tw-flex tw-flex-col">
                    <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Máximo Permitidos</label> 
                    <input
                      type="number"
                      placeholder="Máximo Permitidos"
                      value={maximoPermitidos}
                      onChange={(e) => setMaximoPermitidos(e.target.value)}
                      required
                      className="input-user"
                    />
                  </div>

                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={restringirReservas}
                      onChange={(e) => setRestringirReservas(e.target.checked)}
                    />
                    Restringir reservas por categoría
                  </label>

                  <button type="submit" className="btn-purple tw-col-span-2">
                    Crear configuración
                  </button>
                </form>
              </div>
            )}

            {/* Formulario de actualización */}
            {editId && (
              <div className="tw-border tw-border-zinc-200 tw-rounded-lg tw-p-4 tw-my-5">
                <h3 className="tw-font-extrabold tw-text-lg tw-underline tw-text-purple-700">Editar configuración</h3>
                <form onSubmit={handleUpdate} className="tw-grid tw-grid-cols-[2fr_1fr] tw-gap-4">
                  <div className="tw-flex tw-flex-col">
                    <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Máximo Permitidos</label>  
                    <input
                      type="number"
                      placeholder="Máximo Permitidos"
                      value={maximoPermitidos}
                      onChange={(e) => setMaximoPermitidos(e.target.value)}
                      required
                      className="input-edit"
                    />
                  </div>
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={restringirReservas}
                      onChange={(e) => {
                        console.log("Antes:", restringirReservas);
                        setRestringirReservas(e.target.checked);
                        console.log("Después:", e.target.checked);
                      }}
                    />

                    Restringir reservas por categoría
                  </label>
                  <button type="submit" className="btn-purple tw-col-span-2">
                    Actualizar configuración
                  </button>
                </form>
              </div>
            )}
          </div>
        </main>
    </Modal>
  );
};

export default BloqcatModal;